<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="keyword" placeholder="请输入关键字" style="width:140px;margin-right: 16px;" @keyup.enter.native="changeSearch"></el-input>
			<el-select class="titleSelect" v-model="curTabIndex" @change="changeSearch" placeholder="请选择状态" style="width:120px">
				<el-option
				v-for="item in [{value:1,label:'全部状态'}, {value:2,label:'待签署'}, {value:3,label:'已签署'}, {value:6,label:'待完善'}, {value:5,label:'已失效'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-select class="titleSelect" v-model="type" @change="changeSearch" placeholder="请选择业务分类" style="width:120px">
				<el-option
				v-for="item in [{value:0,label:'全部分类'},{value:2,label:'洗美'}, {value:6,label:'寄养'}, {value:5,label:'医疗服务'}, {value:8,label:'活体'}, {value:3,label:'病例'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-select class="titleSelect" v-model="signType" @change="changeSearch" placeholder="请选择印章类型" style="width:120px">
				<el-option
				v-for="item in [{value:0,label:'全部印章'},{value:1,label:'公章'}, {value:2,label:'合同章'}, {value:3,label:'法人章'}, {value:4,label:'财务章'}, {value:5,label:'发票章'}, {value:6,label:'其他用章'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-select v-model="shopId" class="titleSelect" @change="changeSearch" placeholder="请选择门店" style="width:120px">
				<el-option v-for="item in [{shop_name:'全部门店',shop_id:''}].concat(shopList)" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" >
				</el-option>
			</el-select>
			<el-date-picker v-model="datetimerange" @change="changeSearch" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" style="margin-right:16px">
			</el-date-picker>
			<el-button type="primary" plain @click="reset">重置</el-button>
			<el-button  @click="down">下载</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" :selectable="function(row){return row.isCompleteInfo===true&&row.isSignName===true}">
				</el-table-column>
				<el-table-column label="文件编号" prop="contractNum" >
				</el-table-column>
				<el-table-column label="业务类型" prop="medicalServiceName" width="80">
					<template slot-scope="props">
						<span v-if="props.row.contractType===2">洗美</span>
						<span v-if="props.row.contractType===6">寄养</span>
						<span v-if="props.row.contractType===5">医疗服务</span>
						<span v-if="props.row.contractType===8">活体</span>
						<span v-if="props.row.contractType===3">病例</span>
					</template>
				</el-table-column>
				<el-table-column label="门店" prop="medicalServiceName" width="80">
					<template slot-scope="props">
						{{$dict.getShopNameById(props.row.shopId)}}
					</template>
				</el-table-column>
				<el-table-column label="顾客" prop="memberName" >
				</el-table-column>
				<el-table-column label="手机号" prop="memberMobile" >
				</el-table-column>
				<el-table-column label="宠物" prop="petName" >
				</el-table-column>
				<el-table-column label="签署状态" prop="birthDay" width="80">
					<template slot-scope="props">
						<span v-if="props.row.state===2" style="color:#F56C6C;">已失效</span>
						<span v-if="props.row.state===1">
							<span v-if="props.row.signState===1" style="color:#F56C6C;">待签署</span>
							<span v-if="props.row.signState===2">已签署</span>
							<span v-if="props.row.signState===3">已领走</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="完善状态" prop="birthDay" width="80">
					<template slot-scope="props">
						<span v-if="props.row.isCompleteInfo===true">已完善</span>
						<span v-else style="color:#F56C6C;">未完善</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="typeName" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTimeStamp,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签署时间" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.signTime,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="props">
						<!-- <el-button type="text" size="mini" @click="$router.push({path:'/yiliao/ylfwSee?id='+props.row.id})">签约</el-button> -->
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-if="props.row.state === 1" type="text" size="mini" @click="toVoid(props.row)">作废</el-button>
						<el-button type="text" size="mini" @click="del(props.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				// 筛选
				keyword:'',
				desc:true, // 排序
				curTabIndex:1,
				type:0,  // 文件类型
				signType:0,  // 印章类型
				shopId:'',  // 所选门店
				shopList:this.$store.state.allShopList,
				datetimerange:[],  // 创建时间
				
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 下载
				downList:[],
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 关键字
			reset(){
				this.keyword = ''
				this.curTabIndex = 1
				this.type = 0
				this.signType = 0
				this.shopId = ''
				this.datetimerange = []
				this.page.page = 1;
				this.getTableData();
			},
			changeSearch(){
				this.page.page = 1;
				this.getTableData();
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let signState = 0
				let state = 0
				let completeState = 0
				if(this.curTabIndex===1){signState = 0;state = 0;completeState = 0;
				}else if(this.curTabIndex===2){signState = 1;state = 1;completeState = 0;
				}else if(this.curTabIndex===3){signState = 2;state = 1;completeState = 0;
				}else if(this.curTabIndex===4){signState = 3;state = 1;completeState = 0;
				}else if(this.curTabIndex===5){signState = 0;state = 2;completeState = 0;
				}else if(this.curTabIndex===6){signState = 0;state = 1;completeState = 1;}
				let params = {
					"keyword": this.keyword,
					shopId:this.shopId,
					"contractType": this.type===0?[]:[this.type],  // 
					"sealType": this.signType===0?[]:[this.signType],  // 
					"beginTime": "",
					"endTime": "",
					"signBeginTime": "", // 签约开始时间
					"signEndTime": "",  // 签约结束时间
					"desc":this.desc,
					"signState":signState,  // 0不限；1待签署；2已签署；3已领走
					"state":state, // 0不限 1待完成；2已完成；3失效
					completeState:completeState,  // 0不限；1未完善；2已完善
					isLink:-1,   // -1不限；0未关联；1已关联
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				if(this.datetimerange&&this.datetimerange.length===2){
					params.beginTime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/Order/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_business+'/api/Contract/Order/Detail', {contractNum:row.contractNum}).then(res => {
					loading.close()
					if (res.code == 0) {
						// this.pdfUrl = res.data.contractPdfUrl;
						window.open(res.data.signContractPdfUrl)
					}
				})
			},
			// 作废
			toVoid(row){
				this.$confirm('确定要作废吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_business+'/api/Contract/Order/Update', {contractNum:row.contractNum}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_business+'/api/Contract/Order/Delete', {contractNum:row.contractNum}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 下载
			handleSelectionChange(val) {
				this.downList = val;
			},
			down(){
				if(this.downList.length===0){
					this.$message({
						message: '请选择要下载的文件',
						type: 'error'
					});
					return ;
				}
				for(let i=0;i<this.downList.length;i++){
					const iframe = document.createElement("iframe");
					iframe.style.display = "none"; 
					iframe.style.height = 0; 
					iframe.src = this.downList[i].signContractUrl;
					document.body.appendChild(iframe);
					setTimeout(()=>{
						iframe.remove();
					},100000);
				}
			},
		},
	}
</script>
<style scoped lang="scss">
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>

